/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Free_DescInputs */

const en_landing_pricing_free_desc = /** @type {(inputs: Landing_Pricing_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For getting started`)
};

const zh_landing_pricing_free_desc = /** @type {(inputs: Landing_Pricing_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上手体验`)
};

/**
* | output |
* | --- |
* | "For getting started" |
*
* @param {Landing_Pricing_Free_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_free_desc = /** @type {((inputs?: Landing_Pricing_Free_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Free_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_free_desc(inputs)
	return zh_landing_pricing_free_desc(inputs)
});
export { landing_pricing_free_desc as "landing.pricing.free_desc" }